import React from 'react';
import {Marker} from 'react-leaflet';
import L from "leaflet";


const MapMarker = ({position, name, num, projectId}) => {

    const markerIcon = L.divIcon({
        className: 'map-marker ',
        popupAnchor: [0, -30],
        iconSize: null,
        html: `<div class="num">${num}</div><div class="label">${name} »</div>`
    });

    return <Marker position={position} icon={markerIcon} onClick={() => {
        window.location.href=`/projects?city=${projectId}&search=`
    }}/>;
};

MapMarker.defaultProps = {
    children: null,
    icon: 'face'
};

export default MapMarker;
